import React from "react";
import  { useState, useEffect } from 'react';
import './classes/BasketballAgency.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";
import SalespersonSidebar from "./SalespersonSidebar";

const BasketballAgency = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [basketballDirectors, setBasketballDirectors] = useState([]);
    const [blogData, setBlogData] = useState([]);
    const app_url = configData.APP_URL;

    useEffect(() => {

         const basketballDirectors = [
             {
                name: "Bret Kanis",
                image: "/basic/web/images/agent/picture-1427-1441823206.jpg",
                link: "/agent/bret-kanis",
                bio: ["SMWW NBA Agent"]
            }, 
            {
                name: "Dr. Lynn Lashbrook",
                image: "/basic/web/images/agent/picture-2742-1696447573.jpg",
                link: "/agent/dr.-lynn-lashbrook",
                bio: ["SMWW Agency President & Founder"]
            }
        ];
        setBasketballDirectors(basketballDirectors);
    },[]);

    useEffect(() => {
        Promise.all([
            getagencynewslist()
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    async function getagencynewslist() {
        try {
            const response = await fetch(
                app_url+'smwwblog/getagencynewslist',
                {
                    method: "GET",
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setBlogData(responsedata.data.result);
            }
        } catch (error) {
            console.error(error);
        }finally {
            // Set loading to false after fetch completes (success or error)
        }
    }  

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="basketball-agency-banner-main">
            <div className="sports_agent_career_banner jobs_in_sports_banner" style={{"display":"inline-block","width":"100%"}}>
            <img className="medium_sized_image desktop-baseball-banner-img ban-img" src="/basic/web/images/agent/basketball_agency.png" style={{"width":"100%"}}/>
            <img className="medium_sized_image desktop-soccer-banner-img mobile_ban_img" src="/basic/web/images/agent/mobile_basketball.png" style={{"width":"100%"}}/>
          <div
            className="img_descp"
            style={{
                color: "white",
                position: "absolute",
                marginTop: "-21%",
                marginLeft: "25%",
                textShadow: "2px 2px 8px black, 0 0 25px black",
                filter: "drop-shadow(2px 2px 0px black)"
            }}
            >
            <h1
                className="h1_img_descp"
                style={{
                fontSize: "3.8vw",
                fontWeight: "bold"
                }}
            >
                SMWW Basketball Agency
            </h1>

            <h2
                className="h2_img_descp"
                style={{
                fontSize: "2.24vw"
                }}
            >
                An extensive network of Agent Advisors <br />
                representing basketball players throughout <br />
                the world.
            </h2>
            </div>

            </div>
  
            <div id="main" className="basketball-agency-main">
                <Helmet><title>SMWW Basketball Agency</title></Helmet>
                <div className="left basketball-agency-left">
                    <div className="view-content">
                    <h2>Basketball Directors</h2>
                    <div className="item-list mentors-wrapper">
                    <ul>
                        {/* Desktop Wrapper */}
                        <div className="des_sports_wrapper">
                        {basketballDirectors.map((director, index) => (
                            <li
                            key={index}
                            className={`views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                            } ${index === 0 ? "views-row-first" : ""} ${
                                index === basketballDirectors.length - 1 ? "views-row-last" : ""
                            }`}
                            >
                            <div className="views-field views-field-picture">
                                <div className="field-content">
                                <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                />
                                </div>
                            </div>

                            <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                <a href={director.link}>{director.name}</a>
                                </div>
                            </div>

                            <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                <ul>
                                    {director.bio.map((item, i) => (
                                    <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </li>
                        ))}
                        </div>

                        {/* Mobile Wrapper */}
                        <div className="mob_sports_wrapper">
                        {basketballDirectors.map((director, index) => (
                            <div
                            key={index}
                            className={index % 2 === 0 ? "mob_sports_wrapper_odd" : "mob_sports_wrapper_even"}
                            style={{ float: index % 2 === 0 ? "left" : "right", width: "49%" }}
                            >
                            <li
                                className={`sports_directors_li views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                                } ${index === 0 ? "views-row-first" : ""} ${
                                index === basketballDirectors.length - 1 ? "views-row-last" : ""
                                }`}
                            >
                                <div className="views-field views-field-picture">
                                <div className="field-content">
                                    <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                    />
                                </div>
                                </div>

                                <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                    <a href={director.link}>{director.name}</a>
                                </div>
                                </div>

                                <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                    <ul>
                                    {director.bio.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                            </li>
                            </div>
                        ))}
                        </div>
                    </ul>
                    </div>

                </div>
                </div>
                <div className="center left-center">
                   <div className="basketball-agency-center">
                        <h1>SMWW Basketball Agency</h1>
                        <p><img className="imgfulli" src="/basic/web/images/agent/basketball1.jpg"  style={{"float": "right", "marginLeft": "9px", "marginRight": "9px"}}/>SMWW basketball has relationships with front office personnel and coaches all over the NBA and International markets. With a strong presence both domestically and internationally, SMWW's unique business model has opened doors in every major market for basketball and awarded our client's lucrative playing contracts. SMWW has also formed relationships with elite companies in apparel, entertainment, financial management, athletic training, legal counsel and athletic training to provide access to the best opportunities and advice possible.</p>
                        <p><img className="imgfulli" src="/basic/web/images/agent/basketball2.jpg"  style={{"float": "left", "marginLeft": "9px", "marginRight": "12px"}}/>With over 15 years of industry experience, SMWW has a wide variety of resources and can offer services to meet each individual client's needs. SMWW basketball sports agents work closely with our alliances to maximize opportunities for our clients, both on and off the court, in the USA or globally. We are here to give a variety of advice, professional guidance, mentoring, and strategic counseling from a worldwide team of experience. The athlete gets the advantage of numerous professionals and a wealth of expertise of a large agency, yet the hands-on attention from an individual agent.</p>
                        <p>We at Sports Management Worldwide think our clients deserve the best of worlds, the best professional guidance available and the highest quality and quantity of attention an athlete needs to promote themselves. The SMWW personnel and consultants consist of former ballplayers, NBA front office personnel, ESPN analysts, professional NBA scouts, athletic trainers, coaches, top endorsement negotiators in the country, and more importantly our own Agent Advisors.</p>
                        <div style={{
                            listStyle: "none",
                            boxSizing: "border-box",
                            margin: 0,
                            padding: 0,
                            border: 0,
                            fontFamily: "sans-serif",
                            fontSize: "14px",
                            backgroundColor: "rgb(246, 245, 245)",
                            color: "rgb(255, 0, 0)"
                            }}>
                            <em style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                lineHeight: "18px"
                            }}>
                                 If you are a basketball player looking for representation, we look forward to discussing your career and finding options available to you. Please complete our
                            </em>
                            <span style={{color: "rgb(0, 0, 0)"}}> </span>
                            <a href="/lookingforagent.php" style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                color: "rgb(33, 61, 134)",
                                fontSize: "14px",
                                fontFamily: "inherit",
                                fontStyle: "inherit",
                                backgroundColor: "rgb(246, 245, 245)",
                                outline: 0,
                                verticalAlign: "baseline"
                            }}>
                                online application
                            </a>
                            <span style={{color: "rgb(0, 0, 0)"}}>. </span>
                            </div>
                           <p>
                        <a
                            className="reddbtnn"
                            href="/agents/basketball"
                            style={{
                            width: '80%',
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(rgb(254, 0, 0) 0%, rgb(182, 0, 0) 100%)',
                            backgroundColor: 'rgb(255, 255, 255)',
                            }}
                        >
                            VIEW OUR BASKETBALL AGENTS
                        </a>
                        </p>

                    </div>
                </div>
                <div className="right agent-domain-sports">
                    <AgencySidebar/>
                    <SalespersonSidebar />
                    <h2>SMWW Sports Agency News</h2>
                    <div className="agency_blog">
                        <ul className="list-unstyled mb-0">
                            {blogData.slice(0, 5).map((post, index) => (
                            <div key={index}>
                                <li
                                style={{
                                    listStyleType: "none",
                                    listStyle: "outside none"
                                }}
                                >
                                <a href={post.link}>
                                    <img src={post.image} alt={post.title} />
                                </a>

                                <p className="stwwt-post-title">
                                    <a className="post-para" href={post.link}>
                                    {post.title}
                                    </a>
                                    <br />
                                    <a href={post.link}>
                                    <span className="button mr-1 arrow">Read Article</span>
                                    </a>
                                </p>
                                </li>

                                {/* Separator */}
                                {index < blogData.slice(0, 5).length - 1 && <li className="sepline">&nbsp;</li>}
                            </div>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        )}
        </>
    );
};
export default BasketballAgency;